import React from 'react';
import { useParams, Link } from 'react-router-dom';

/**
 * Legal pages — Impressum, Datenschutzerklärung (Privacy), and Cookie notice.
 * All business-specific details are [PLACEHOLDER]s that TJ must fill before launch.
 */
const BUSINESS = {
    name: '[PLACEHOLDER: Legal business name / GmbH]',
    owner: '[PLACEHOLDER: Owner / Geschäftsführer name]',
    street: '[PLACEHOLDER: Street + number]',
    city: '[PLACEHOLDER: ZIP + City]',
    country: 'Germany',
    email: '[PLACEHOLDER: contact email]',
    phone: '[PLACEHOLDER: phone]',
    vat: '[PLACEHOLDER: USt-IdNr. / VAT ID]',
};

const wrap = { maxWidth: 720, margin: '0 auto', padding: '24px 18px', lineHeight: 1.6 };
const h = { marginTop: 24 };

function Impressum() {
    return (
        <div style={wrap}>
            <h3>Impressum</h3>
            <p>Angaben gemäß § 5 TMG / Information pursuant to § 5 TMG (German Telemedia Act):</p>
            <p>
                <strong>{BUSINESS.name}</strong><br />
                {BUSINESS.street}<br />
                {BUSINESS.city}<br />
                {BUSINESS.country}
            </p>
            <p><strong>Vertreten durch / Represented by:</strong><br />{BUSINESS.owner}</p>
            <p>
                <strong>Kontakt / Contact:</strong><br />
                Email: {BUSINESS.email}<br />
                Tel: {BUSINESS.phone}
            </p>
            <p><strong>Umsatzsteuer-ID / VAT ID:</strong><br />{BUSINESS.vat}</p>
            <p style={h}><strong>Verantwortlich für den Inhalt / Responsible for content (§ 18 Abs. 2 MStV):</strong><br />{BUSINESS.owner}, {BUSINESS.street}, {BUSINESS.city}</p>
            <p className='text-muted'><small>Fill these placeholders with the operating business's real legal details before going live.</small></p>
        </div>
    );
}

function Privacy() {
    return (
        <div style={wrap}>
            <h3>Datenschutzerklärung / Privacy Policy</h3>
            <p><em>Last updated: [PLACEHOLDER: date]</em></p>

            <h5 style={h}>1. Responsible party (Verantwortlicher)</h5>
            <p>{BUSINESS.name}, {BUSINESS.street}, {BUSINESS.city}, {BUSINESS.country}. Email: {BUSINESS.email}.</p>

            <h5 style={h}>2. What data we process</h5>
            <p>When you place an order through this digital menu we process: the name you enter, your optional table number, and your order details (items, quantities, totals). For venue accounts we process the email address and an encrypted (hashed) password. We do not knowingly collect more than is needed to take and fulfil your order.</p>

            <h5 style={h}>3. Legal basis</h5>
            <p>Processing of order data is based on Art. 6(1)(b) GDPR (performance of a contract / pre-contractual steps). Account data for venue owners is processed on the same basis.</p>

            <h5 style={h}>4. Payment data</h5>
            <p>If online payment is enabled, card payments are handled by our payment processor (Stripe). We never see or store your full card details; they are transmitted directly to the processor. See the processor's own privacy policy for details.</p>

            <h5 style={h}>5. Storage &amp; retention</h5>
            <p>Order records are retained for as long as legally required (e.g. tax/accounting obligations) and then deleted. Account data is kept while the account is active.</p>

            <h5 style={h}>6. Cookies &amp; local storage</h5>
            <p>This app uses only strictly-necessary browser local storage to keep you logged in and to remember your cart. No third-party advertising or tracking cookies are used.</p>

            <h5 style={h}>7. Your rights</h5>
            <p>You have the right to access, rectify, erase, restrict, and port your data, and to object to processing (Art. 15–21 GDPR). Contact {BUSINESS.email} to exercise these rights. You may also lodge a complaint with a supervisory authority.</p>

            <p className='text-muted'><small>This is a starter template — have it reviewed by a lawyer and complete all [PLACEHOLDER] fields before launch.</small></p>
        </div>
    );
}

const Legal = () => {
    const { page } = useParams();
    return (
        <div>
            {page === 'impressum' ? <Impressum /> : <Privacy />}
            <div style={{ textAlign: 'center', padding: '8px 0 32px' }}>
                <Link to='/legal/impressum' className='nav-link-color'>Impressum</Link>
                {' · '}
                <Link to='/legal/privacy' className='nav-link-color'>Datenschutz / Privacy</Link>
            </div>
        </div>
    );
};

export default Legal;
